import { render } from "./Header.vue?vue&type=template&id=57a963c8&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=57a963c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a963c8"],['__file',"src/views/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57a963c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57a963c8', __exports__)) {
    api.reload('57a963c8', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=57a963c8&scoped=true", () => {
    api.rerender('57a963c8', render)
  })

}


export default __exports__